export default __webpack_public_path__ + "static/media/FraseES.72f44277.png";